export class HeaderType {
	constructor(name) {
		this.name = name;
	}
	toString() {
		return this.name;
	}
	toJSON() {
		return this.name;
	}
}

export const NO_HEADER = new HeaderType("NO_HEADER");
export const CONTACT_PAGE_HEADER = new HeaderType("CONTACT_PAGE_HEADER");
export const STEPPER_HEADER = new HeaderType("STEPPER_HEADER");
export const EMPTY_HEADER = new HeaderType("EMPTY_HEADER");
export const GETTING_STARTED_HEADER = new HeaderType("GETTING_STARTED_HEADER");
export const PRIVACY_POLICY_HEADER = new HeaderType("PRIVACY_POLICY_HEADER");
